import {POST_RNH_NEW_NOTE, UPDATE_RNH_NOTE_DETAIL} from '../../../actions/actiontypes';
import {EngagementCommentStatus} from '../../../util/uiconstants';

export default (technology, documentId, data, actionType, previousStatusId) => {
	const {
		isEPSignoffUserRequired = null,
		isEQRSignoffUserRequired = null,
		documentName = null,
		documentId: altDocumentId = null
	} = data;
	if (technology === null) return null;
	return {
		...technology,
		relatedDocuments: technology?.relatedDocuments?.map((document) => {
			if ([documentId, altDocumentId].includes(document.id)) {
				let engagementReviewNoteCount = document?.engagementReviewNoteCount;
				if (actionType === POST_RNH_NEW_NOTE || (actionType === UPDATE_RNH_NOTE_DETAIL && data?.isOpening))
					engagementReviewNoteCount = engagementReviewNoteCount + 1;
				if (
					actionType === UPDATE_RNH_NOTE_DETAIL &&
					data?.isClosing &&
					previousStatusId === EngagementCommentStatus.open &&
					engagementReviewNoteCount > 0
				)
					engagementReviewNoteCount = engagementReviewNoteCount - 1;
				return {
					...document,
					isEPSignoffUserRequired: isEPSignoffUserRequired ?? document.isEPSignoffUserRequired,
					isEQRSignoffUserRequired: isEQRSignoffUserRequired ?? document.isEQRSignoffUserRequired,
					documentName: documentName ?? document.documentName,
					engagementReviewNoteCount
				};
			}
			return document;
		})
	};
};
